var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("chart-component", {
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function () {
            return [_vm._v(" " + _vm._s(_vm.title) + " ")]
          },
          proxy: true,
        },
        {
          key: "switcher",
          fn: function () {
            return [
              _c("timeline-period-switcher", {
                staticClass: "switcher",
                on: {
                  change: function ($event) {
                    return _vm.switchChartPeriod($event)
                  },
                },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "chart",
          fn: function () {
            return [
              _c("timeline-of-total-costs-chart", {
                attrs: {
                  "hide-title": "",
                  period: _vm.period,
                  height: _vm.height,
                  "shared-idea": _vm.sharedIdea,
                  "chart-animations": _vm.chartAnimations,
                },
              }),
            ]
          },
          proxy: true,
        },
        !_vm.hideRightSide
          ? {
              key: "right-side",
              fn: function () {
                return [
                  _c(
                    "chart-component-right-side",
                    [
                      _c("total-amount", {
                        staticClass: "mb-3",
                        attrs: {
                          amount: _vm.totalAmount,
                          text: _vm.$t("charts.totalCost"),
                        },
                      }),
                      _c(
                        "div",
                        [
                          _vm._l(_vm.byYearAmount, function (year, index) {
                            return [
                              _c("year-info", {
                                key: index,
                                staticClass: "mb-3",
                                attrs: {
                                  "avatar-text": `Y${index + 1}`,
                                  money: year,
                                  text: _vm.getTotalExpensesEndOfYearDateString(
                                    index
                                  ),
                                },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "bottom",
          fn: function () {
            return [_vm._t("bottom")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }